import { useContext } from 'react';

import { FeatureTogglesContext } from 'context/FeatureTogglesProvider';

export function useFeatureToggles(name: string) {
  const features = useContext(FeatureTogglesContext);
  return features[name];
}

export default useFeatureToggles;
